import { AxiosResponse } from 'axios';
import { IncomingHttpHeaders } from 'http';
import { JobCountResponse as V2Response } from '@doda/api-client/api/job/@types';
import { Methods as V2Methods } from '@doda/api-client/api/job/api/job/v1/jobs/count';
import { JobCountResponse as V1Response } from '@doda/api-client/aspida/@types';
import { Methods as V1Methods } from '@doda/api-client/aspida/api/v1/jobs/count/index';
import { apiClient as jobApiClient } from '@doda/api-client/util/jobApiClient';
import { appAxios } from '../libs/axios/appAxios';

export type JobCountQuery = NonNullable<V1Methods['get']['query']>;
type V2JobCountQuery = NonNullable<V2Methods['get']['query']>;

export const getJobCount = async (
  useV2JobCountApi: boolean,
  params?: JobCountQuery,
  headers?: IncomingHttpHeaders
): Promise<V1Response> => {
  return useV2JobCountApi
    ? getJobCountV2({ params, headers })
    : getJobCountV1(params, headers);
};

export const getJobCountV1 = async (
  params?: JobCountQuery,
  headers?: IncomingHttpHeaders
): Promise<V1Response> => {
  return appAxios({
    url: '/api/v1/jobs/count',
    headers,
    params,
  }).then((res: AxiosResponse<V1Response>) => {
    return res.data;
  });
};

export const getJobCountV2 = async ({
  params,
  headers,
}: {
  params?: JobCountQuery;
  headers?: IncomingHttpHeaders;
}): Promise<V2Response> => {
  return jobApiClient.api.job.v1.jobs.count.$get({
    query: toV2Query(params),
    config: { headers },
  });
};

const toV2Query = (
  hydrogenQuery: JobCountQuery | undefined
): V2JobCountQuery => {
  const { jid, lowerLimitIncome, upperLimitIncome, ...others } =
    hydrogenQuery ?? {};

  const nextQuery = {
    ...others,
    // 以下は項目名を変換する。
    jobId: jid?.map((s) => Number(s)),
    lowerLimitSalary: lowerLimitIncome,
    upperLimitSalary: upperLimitIncome,
  };

  // undefinedもしくは空配列は項目自体を削除する (クエリ文字列に不要な'&'を含めないようにするため)。
  return Object.fromEntries(
    Object.entries(nextQuery).filter(([, value]) => isNotEmpty(value))
  );
};

const isNotEmpty = (value: V2JobCountQuery[keyof V2JobCountQuery]): boolean => {
  if (value === undefined) return false;

  if (!Array.isArray(value)) return true;

  return value.length !== 0;
};
